var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.236 10.354h-.676v-.034H12v3.36h4.748A5.04 5.04 0 0 1 12 17.04 5.04 5.04 0 0 1 6.96 12 5.04 5.04 0 0 1 12 6.96c1.285 0 2.454.484 3.344 1.276l2.375-2.375A8.36 8.36 0 0 0 12 3.6 8.4 8.4 0 0 0 3.6 12a8.4 8.4 0 0 0 8.4 8.4 8.4 8.4 0 0 0 8.236-10.046Z"
  })));
};

export default SvgGoogle;